import { render, staticRenderFns } from "./order_shipping_status_pill.vue?vue&type=template&id=4b2b0b75&"
import script from "./order_shipping_status_pill.vue?vue&type=script&lang=coffee&"
export * from "./order_shipping_status_pill.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports